import { useEffect, useState } from "react";
import { Phone, Wrench } from "lucide-react";
import { useBookingMode } from "@/lib/bookingMode";
import { telHref } from "@/components/PhoneVerifyDialog";

const SEEN_KEY = "utile_maintenance_popup_seen";

// Homepage notice while bookings are on phone verification; once per browser session
export default function HomeMaintenancePopup() {
  const mode = useBookingMode();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (mode?.phone_verification && !sessionStorage.getItem(SEEN_KEY)) setOpen(true);
  }, [mode]);

  if (!open) return null;
  const close = () => { sessionStorage.setItem(SEEN_KEY, "1"); setOpen(false); };

  return (
    <div data-testid="home-maintenance-popup" role="dialog" aria-modal="true" aria-labelledby="hm-title" className="fixed inset-0 z-[90] bg-black/75 backdrop-blur-sm flex items-center justify-center p-4 animate-in fade-in duration-500">
      <div className="relative w-full max-w-lg overflow-hidden bg-[#0a0a0a] border border-white/10 text-white shadow-[0_30px_80px_-20px_rgba(34,255,102,0.4)] animate-in zoom-in-95 slide-in-from-bottom-4 duration-500">
        <div className="h-1.5 w-full bg-[#22ff66]" />
        <div className="p-7 md:p-9">
          <div className="flex items-center gap-2 text-[#22ff66] text-[11px] uppercase tracking-[0.3em] font-bold mb-4">
            <Wrench className="w-4 h-4" /> Utile Rent
          </div>
          <h2 id="hm-title" className="font-display font-black uppercase text-3xl md:text-4xl leading-none mb-5">Sito in allestimento</h2>
          <div className="space-y-3 text-sm md:text-base text-white/80 leading-relaxed mb-6">
            <p className="text-white font-semibold">Stiamo aggiornando il nostro sito, i prezzi e le offerte per offrirti un servizio ancora migliore!</p>
            <p>Il nostro servizio di noleggio è regolarmente operativo.</p>
            <p>Per conoscere le tariffe aggiornate, verificare la disponibilità delle vetture e scoprire le promozioni, ti invitiamo a contattarci telefonicamente.</p>
          </div>
          <p className="text-[#22ff66] font-display font-bold text-sm md:text-base mb-7">UTILE RENT – La tua mobilità, senza pensieri.</p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a data-testid="home-maintenance-call" href={telHref(mode?.phone)} onClick={() => sessionStorage.setItem(SEEN_KEY, "1")} className="w-full sm:flex-1 shrink-0 inline-flex items-center justify-center gap-2 h-12 px-4 bg-[#22ff66] text-black rounded-full text-xs uppercase tracking-widest font-bold hover:-translate-y-0.5 transition-transform">
              <Phone className="w-4 h-4" /> Contattaci telefonicamente
            </a>
            <button type="button" data-testid="home-maintenance-continue" onClick={close} className="w-full sm:flex-1 shrink-0 inline-flex items-center justify-center h-12 px-4 border border-white/25 hover:border-white rounded-full text-xs uppercase tracking-widest font-bold transition-colors">
              Continua la navigazione
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
